exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-7386cd74] {\n  color: #232323;\n  font-size: 1rem;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n", ""]);

// exports
